<div class="container-fluid" style="height: calc(100% - 80px) !important;margin-top: 80px;">
    <!-- <button appPreventDoubleClick class="floating-button" mat-fab color="primary" (throttledClick)="save();">
        <mat-icon>save</mat-icon>
    </button> -->
    <app-speed-dial-fab (clicked)="dispatch($event)" [options]="FabOptions"></app-speed-dial-fab>

    <div class="position-fixed justify-content-center" style="left: calc(100% /2 - 38px); z-index: 666; margin-top: -80px;">
        <circle-progress [percent]="Total" [backgroundPadding]="1" [radius]="32" [space]="-4" [innerStrokeColor]="'#e7e8ea'" [innerStrokeWidth]="5"
                         [outerStrokeColor]="'#fb903e'" [outerStrokeWidth]="5" [animateTitle]="false" [showTitle]="true" [titleFontSize]="'18'" [animationDuration]="1000"
                         [startFromZero]="false" [showSubtitle]="false" [showUnits]="true" [unitsFontSize]="'16'">
        </circle-progress>
    </div>

    <div class="row justify-content-center" style="overflow-y: auto; height: calc(100%);">
        <div class="col-12 col-sm-6 col-md-4 col-xl-2 my-1" *ngFor="let s of SampleTakingList">
            <div class="border rounded-1 background-light p-3 w-100 d-flex flex-column" style="min-height: 24rem;" (click)="SetSectedSubstrat(s)">

                <!-- <h5 class="card-header">{{getTypeOfSubstratName(s.Type)}}</h5> -->
                <div class="row">
                    <h2 class="col text-center fw-bold"> {{getTypeOfSubstratName(s.Type)}}</h2>
                </div>
                <div *ngIf="!s.Presence" class="row justify-content-center">
                    <circle-progress class="col-auto" [percent]="s.Pourcentage" [backgroundPadding]="1" [radius]="20" [space]="-2" [innerStrokeColor]="'#e7e8ea'"
                                     [innerStrokeWidth]="3" [outerStrokeColor]="'#f50057'" [outerStrokeWidth]="3" [animateTitle]="false" [showTitle]="true"
                                     [titleFontSize]="'13'" [animationDuration]="1000" [startFromZero]="false" [showSubtitle]="false" [showUnits]="true">
                    </circle-progress>
                </div>

                <!-- <h5 class="card-title">{{s.Pourcentage}}</h5> -->
                <!-- <p class="card-text">{{s}}</p> -->
                <div class="row " *ngFor="let v of s.PrelevementVitesses">
                    <div class="p-0" style="width: 5px;"
                         [class.n1]="v.Vitesse === 1"
                         [class.n2]="v.Vitesse === 2"
                         [class.n3]="v.Vitesse === 3"
                         [class.n4]="v.Vitesse === 4"
                         [class.n5]="v.Vitesse === 5"
                         [class.n6]="v.Vitesse === 6">
                    </div>
                    <div class="col align-self-center">
                        {{getClasseVitesseName(v.Vitesse)}}
                    </div>
                    <div class="col-auto justify-content-center">
                        <mat-icon class="align-self-center" *ngIf="v.Representativite === 1">looks_one</mat-icon>
                        <mat-icon class="align-self-center" *ngIf="v.Representativite === 2">looks_two</mat-icon>
                        <mat-icon class="align-self-center" *ngIf="v.Representativite === 3">looks_3</mat-icon>
                        <mat-icon class="align-self-center" *ngIf="v.Representativite === 4">looks_4</mat-icon>
                        <mat-icon class="align-self-center" *ngIf="v.Representativite === 5">looks_5</mat-icon>
                    </div>
<!-- 
                </div>
                <div class="row mt-2"> -->
                    <!-- <span *ngFor="let pv of s.PrelevementVitesses"> -->
                        <div class="col-12 mb-3">
                            
                            <button *ngFor="let p of v.Prelevements" appPreventDoubleClick mat-mini-fab
                            [class.n1]="v.Vitesse === 1"
                            [class.n2]="v.Vitesse === 2"
                            [class.n3]="v.Vitesse === 3"
                            [class.n4]="v.Vitesse === 4"
                            [class.n5]="v.Vitesse === 5"
                            [class.n6]="v.Vitesse === 6"
                            [matBadge]="p.Profondeur ? '' : 1" matBadgeColor="accent" matBadgePosition="below after"
                            class="mx-1"
                            (throttledClick)="SetSectedSubstrat(s); openPrelevementDialog(p, v, s.Type);">
                            <span class="fw-bold">P{{p?.Numero}}</span>
                        </button>
                    </div>
                    <!-- </span> -->
                </div>

                <div class="row d-flex justify-content-end mt-auto g-0">
                    <button appPreventDoubleClick class="col-auto" mat-icon-button color="primary" (throttledClick)="deleteSubstrat(s)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button appPreventDoubleClick class="col-auto" mat-icon-button color="primary" (throttledClick)="openSubstratDialog(s);">
                        <mat-icon>edit</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-xl-2 my-1" *ngFor="let s of PresenceList">
            <div class="border rounded-1 background-light p-3 d-flex flex-column w-100" style="min-height: 24rem;" (click)="SetSectedSubstrat(s)">

                <!-- <h5 class="card-header">{{getTypeOfSubstratName(s.Type)}}</h5> -->
                <div class="row">
                    <h2 class="col text-center fw-bold"> {{getTypeOfSubstratName(s.Type)}}</h2>
                </div>

                <p class="font-weight-bold text-center" style="font-size: 32px;">P</p>

                <div class="row" *ngFor="let v of s.PrelevementVitesses">
                    <div style="width: 5px;"
                         [class.n1]="v.Vitesse === 1"
                         [class.n2]="v.Vitesse === 2"
                         [class.n3]="v.Vitesse === 3"
                         [class.n4]="v.Vitesse === 4"
                         [class.n5]="v.Vitesse === 5"
                         [class.n6]="v.Vitesse === 6">
                    </div>
                    <div class="col align-self-center">
                        {{getClasseVitesseName(v.Vitesse)}}
                    </div>
                    <div class="col-1 d-flex justify-content-center">
                        <mat-icon class="align-self-center" *ngIf="v.Representativite === 1">looks_one</mat-icon>
                        <mat-icon class="align-self-center" *ngIf="v.Representativite === 2">looks_two</mat-icon>
                        <mat-icon class="align-self-center" *ngIf="v.Representativite === 3">looks_3</mat-icon>
                        <mat-icon class="align-self-center" *ngIf="v.Representativite === 4">looks_4</mat-icon>
                        <mat-icon class="align-self-center" *ngIf="v.Representativite === 5">looks_5</mat-icon>
                    </div>
                </div>

                <div class="row d-flex justify-content-end mt-auto">
                    <button appPreventDoubleClick class="col-auto" mat-icon-button color="primary" (throttledClick)="deleteSubstrat(s)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button appPreventDoubleClick class="col-auto" mat-icon-button color="primary" (throttledClick)="openSubstratDialog(s);">
                        <mat-icon>edit</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-6 col-md-4 col-xl-2 my-1">
            <div class="card w-100 py-2" style="height: 24rem;">

                <button appPreventDoubleClick class="m-auto" mat-fab color="primary" (throttledClick)="openSubstratDialog();">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>